define('cookieparser',['edaphelpers'], function(edapHelpers) {
    'use strict';

    function CookieParser() {
        var parser = this;

        /**
         *  Returns the window.document
         *
         *  @returns {Object} - Returns the window.document
         */
        parser.getDocument = function() {
            return window.document;
        };


        /**
         *  Returns the window.document.cookies data string
         *
         *  @returns {String} - window.document.cookies data string or an empty string
         */
        parser.getCookies = function() {
            return parser.getDocument().cookie || '';
        };


        /**
         *  Parses the "edapConfig" cookie and returns an object of the data
         *
         *  NOTE: No decoding is done on the keys/values so be careful not to include ";" or "|"
         *  as it would break the parsing
         *
         *  Cookie format should be:
         *      edapConfig=key1=value1|key2=value2|key3=value3|...
         *  will return:
         *      {
         *          key1: value1,
         *          key2: value2,
         *          key3: value3
         *          ...
         *      }
         *
         *  @return {Object} - Object as described in the description above
         */
        parser.getConfigData = function() {
            var edapCookieData = {},
                cookies,
                edapCookieRegexed,
                edapCookieRawData,
                splitEqualsRegExp,
                edapCookieDataParts,
                tmp,
                i,
                len;

            try {
                cookies = parser.getCookies();
                edapCookieRegexed = cookies.match(/edapConfig=([^;]+)(;|$)/);
                edapCookieRawData = (edapCookieRegexed === null ? null : edapCookieRegexed[1]);
                splitEqualsRegExp = new RegExp('=(.+)');

                if (edapCookieRawData !== null) {
                    edapCookieDataParts = edapCookieRawData.split('|');

                    for (i = 0, len = edapCookieDataParts.length; i < len; i++) {
                        tmp = edapCookieDataParts[i].split(splitEqualsRegExp);
                        edapCookieData[tmp[0]] = tmp[1];
                    }
                }
            } catch (err) {
                edapCookieData = {};
                edapHelpers.getEdapGlobal().push(function(edap) {
                    edap.error(err);
                });
            }

            return edapCookieData;
        };
    }

    return new CookieParser();
});

